import { getPropsFromParams } from '../utils.routing'
import MonthlyReport from '@/components/admin/MonthlyReport'
import { adminRouteNames } from '@/routing/routeNames/adminRouteNames'
import AdminDashboard from '@/components/admin/AdminDashboard'
import OrganizationReport from '@/components/admin/OrganizationReport'
import OrganizationSettings from '@/components/admin/OrganizationSettings.vue'
import UserSettings from '@/components/admin/UserSettings.vue'
import EventSettings from '@/components/admin/EventSettings.vue'
import TicketInsuranceReport from '@/components/admin/TicketInsuranceReport.vue'
import OrganizerPayouts from '@/components/admin/OrganizerPayouts.vue'
import TicketSellerPayouts from '@/components/admin/TicketSellerPayouts.vue'
import { allowedUserType } from '@/routing/rules'

import Refunds from '@/components/admin/Refunds.vue'

export const AdminRoutes = [
  {
    path: '/admin-pages/refunds',
    name: adminRouteNames.refunds,
    component: Refunds,
    meta: { title: 'Povrati', rules: [allowedUserType(['SUPER_ADMIN'])], requiresAuthentication: true, redirectIfAuthenticated: false },
  },
  {
    path: '/admin-pages',
    name: adminRouteNames.adminDashboard,
    props: getPropsFromParams,
    component: AdminDashboard,
    meta: {
      title: 'Admin Dashboard',
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/admin-pages/organization-settings',
    name: adminRouteNames.organizationSettings,
    component: OrganizationSettings,
    meta: {
      title: 'Organization Settings',
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/admin-pages/user-settings',
    name: adminRouteNames.userSettings,
    component: UserSettings,
    meta: {
      title: 'User Settings',
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/admin-pages/event-settings',
    name: adminRouteNames.eventSettings,
    component: EventSettings,
    meta: {
      title: 'Event Settings',
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/admin-pages/monthly-report',
    name: adminRouteNames.monthlyReport,
    props: getPropsFromParams,
    component: MonthlyReport,
    meta: {
      title: 'Monthly Report',
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/admin-pages/organizer-payouts',
    name: adminRouteNames.organizerPayouts,
    component: OrganizerPayouts,
    meta: {
      title: 'Organizer Payouts',
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/admin-pages/ticket-seller-payouts',
    name: adminRouteNames.ticketSellerPayouts,
    component: TicketSellerPayouts,
    meta: {
      title: 'Ticket Seller Payouts',
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/admin-pages/ticket-insurance-report',
    name: adminRouteNames.ticketInsuranceReport,
    props: getPropsFromParams,
    component: TicketInsuranceReport,
    meta: {
      title: 'Ticket Insurance Report',
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/admin-pages/:organizationSlug',
    name: adminRouteNames.organizationReport,
    component: OrganizationReport,
    meta: {
      title: 'Organization Report',
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
]
